import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { catchError, map, of } from 'rxjs';

/**
 * Authentication guard that protects routes requiring authentication.
 * Checks if the user is authenticated and has a valid token.
 * Attempts to refresh the token if it's expired.
 *
 * @returns Observable<boolean> - true if user is authenticated, false otherwise
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if token is valid
  if (authService.checkTokenValidity()) {
    return true;
  }

  // Token is invalid or expired, try to refresh
  return authService.refreshToken().pipe(
    map(() => true),
    catchError(() => of(new RedirectCommand(router.parseUrl('/auth/login')))),
  );
};
